export const resolveImageUrl = (url, server) => {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  if (!server) return url;

  const hasTrailingSlash = server.endsWith("/");
  const hasLeadingSlash = url.startsWith("/");

  if (hasTrailingSlash && hasLeadingSlash) {
    return `${server}${url.substring(1)}`;
  }
  if (!hasTrailingSlash && !hasLeadingSlash) {
    return `${server}/${url}`;
  }
  return `${server}${url}`;
};
